export default "__VITE_ASSET__d84a138b__"